import { MultipartItem } from '../types/requestParamsModel';
import {
  WinnerCreateData,
  WinnerData,
  WinnerEditData,
} from '../types/winnerRequest';

export const makeUpWinnersRequest = (
  data: WinnerCreateData | WinnerEditData
): Array<MultipartItem> => {
  let multipartData = Array<MultipartItem>();
  const winnerData: WinnerData = {
    name: data.name,
    description: data.description,
    // videoUrl: data.videoUrl,
    drawDate: data.drawDate,
    isWithoutPhoto: data.photoUrl ? false : true,
    isWithoutPhotoPeople: data.winnerPhotoUrl ? false : true,
    id: data.id,
    sex: data.sex,
    prizeType: data.prizeType,
    prizeTitle: data.prizeTitle,
    prizeLabel: data.prizeLabel,
    ticket: data.ticket,
  };
  if (data.photoUrl) {
    multipartData.push({ image: data.photoUrl.rawFile, id: 'photo' });
  }
  if (data.winnerPhotoUrl) {
    multipartData.push({
      image: data.winnerPhotoUrl.rawFile,
      id: 'photoPeople',
    });
  }
  
  multipartData.push({
    image: new Blob([JSON.stringify(winnerData)], { type: 'application/json' }),
    id: 'winner',
  });
  return multipartData;
};
